import React, { useContext } from 'react';
import './VenueAnalysisBar.scss';
import { VenueAnalysisVenueData } from '../venueAnalysisAggregatedData';
import AppContext from 'app/AppContext';
import classnames from 'classnames';
import { getVenueTypeClass } from 'utils/venueTypeUtils';
import {
    HighlightedVenue,
    isVenueItemHighlighted,
} from 'widgets/venueAnalysis/highlighting';
import { VenueAnalysisSelection } from 'widgets/venueAnalysis/store/component/VenueAnalysisSelection';

export interface VenueAnalysisVenueItemProps {
    venue: VenueAnalysisVenueData;
    venueType: string;
    selection?: VenueAnalysisSelection;
    highlightedVenue?: HighlightedVenue;
    onHighlightedVenueChange?: (venue?: HighlightedVenue) => void;
    onClick: (ev: React.MouseEvent<HTMLDivElement>) => void;
}

export function VenueAnalysisVenueItem({
    venue,
    venueType,
    highlightedVenue,
    selection,
    onHighlightedVenueChange,
    onClick,
}: VenueAnalysisVenueItemProps) {
    const { numberFormat } = useContext(AppContext);

    const isItemHighlighted = isVenueItemHighlighted(
        'Venue',
        highlightedVenue,
        selection,
        venue.highlightItem
    );

    const widthStyle = (width: number) => {
        return { width: `${width}%` };
    };

    return (
        <div
            className={classnames(
                'venue-item',
                isItemHighlighted && 'item-highlight'
            )}
            key={venue.name}
            onMouseOver={() =>
                onHighlightedVenueChange &&
                onHighlightedVenueChange({
                    venueTypeName: venueType,
                    venueName: venue.name,
                })
            }
            onMouseLeave={() =>
                onHighlightedVenueChange && onHighlightedVenueChange(undefined)
            }
            onClick={onClick}
        >
            <div className="text-area">
                <div className="venue-item-name">{venue.name} </div>
                <div className="number">{numberFormat.n0(venue.percent)}%</div>
            </div>
            <div
                className={classnames(
                    'venue-item-bar',
                    getVenueTypeClass(venueType)
                )}
                style={widthStyle(venue.percent)}
            />
        </div>
    );
}
